export default "__VITE_ASSET__1LhnFy97__"